import { useSelector, useDispatch } from 'react-redux';

import { customersGridColumns } from '../../components/customers-grid/columns';
import { EditColumnsModal } from '../../components/modals/edit-columns-modal';
import { customerGridChangeColumns } from '../../store/customers/grid/customers.grid.actions';
import { defaultColumnConfigurations } from '../../store/customers/grid/default-column-configuration';
import Global from '../../store/global-selectors';
import { saveUserSettingGridConfig } from '../../store/user/user.actions';

export const EditCustomersColumnsModalContainer = (props) => {
  const dispatch = useDispatch();

  const activeFilterViewId = useSelector(Global.selectCustomersFilteringActiveFilterViewId);
  const statusViewId = useSelector(Global.selectCustomersViewId);
  const columnConfiguration = useSelector((state) =>
    Global.selectCustomersGridCurrentViewGridConfigOrDefault(state, {
      statusViewId,
      activeFilterViewId,
    }),
  );

  const saveColumnConfiguration = (columns) => {
    dispatch(saveUserSettingGridConfig('customers', statusViewId, activeFilterViewId, columns));
    dispatch(customerGridChangeColumns(statusViewId, activeFilterViewId, columns));
  };

  return (
    <EditColumnsModal
      {...props}
      baseColumns={customersGridColumns}
      columnConfiguration={columnConfiguration}
      defaultColumnConfigurations={defaultColumnConfigurations}
      saveColumnConfiguration={saveColumnConfiguration}
    />
  );
};
